<template>
  <div>
    <template>
      <h4
          class="not-margin"
          :style="{
          fontWeight: 'bold',
          color: '#195BFF',
          fontSize: '18px',
          marginTop: '10px',
        }"
      >
        <i
            class="fal fa-info-circle"
            :style="{ width: '30px', fontSize: '18px' }"
        ></i>
        ແກ້ໄຂຮ້ານຄ້າ Corporate
      </h4>
    </template>

    <!-- General Error Message -->
    <div class="field column" v-if="server_errors.general_error" style="margin-bottom: 10px">
      <div class="notification is-danger">
        <p>{{ server_errors.general_error }}</p>
      </div>
    </div>

    <!-- name -->
    <div class="field column" style="margin-bottom: -10px">
      <div class="control">
        <label class="label">
          ຊື່ຮ້ານ
          <span class="text-danger">* {{ errors.first("name") }}</span>
          <span class="text-danger">
              {{ server_errors.name }}
            </span>
        </label>
        <input
            class="input"
            type="text"
            name="name"
            placeholder="ກະລຸນາປ້ອນກ່ອນ..."
            v-model="item.name"
            v-validate="'required|max:191'"
            :class="{'is-danger': errors.has('name')}"
        />
      </div>
    </div>

    <!-- COD Customer -->
    <div class="field column" style="margin-bottom: -10px">
      <div class="control">
        <label class="label">
          ລູກຄ້າລົງທະບຽນ
          <span class="text-danger">*</span>
          <span class="text-danger">
              {{ server_errors.customer_id }}
            </span>
        </label>
        <CodCustomerSearch
          :initialSelectedCustomer="item.codCustomer"
          @customer-selected="onCodCustomerSelected"
        />
        <input type="hidden" name="customer_id" v-model="item.customer_id" v-validate="'required'" />
        <p class="text-danger" v-if="errors.has('customer_id')">
          ກະລຸນາເລືອກລູກຄ້າ
        </p>
      </div>
    </div>

    <!-- is_active -->
    <div class="field column" style="margin-bottom: -10px">
      <div class="control">
        <label class="label">
          ສະຖານະຮ້ານ
          <span class="text-danger">*</span>
          <span class="text-danger">
              {{ server_errors.is_active }}
            </span>
        </label>
        <div class="columns">
          <div class="field column">
            <div class="control">
              <vs-checkbox v-model="item.is_active" name="is_active" v-validate="'required'">ເປີດບໍລິການ</vs-checkbox>
            </div>
          </div>
        </div>
        <p class="text-danger" v-if="errors.has('is_active')">
          ກະລຸນາເລືອກສະຖານະຮ້ານ
        </p>
      </div>
    </div>

    <!-- Package Selection -->
    <div class="field column" style="margin-bottom: -10px">
      <div class="control">
        <label class="label">
          ໃຊ້ແພັກເກດລາຄພິເສດ
          <span class="text-danger">
              {{ server_errors.package_name_group }}
            </span>
        </label>
        <div class="columns">
          <div class="field column is-narrow">
            <div class="control">
              <vs-checkbox
                :value="item.package_name_group === 'hal_express_package_special_group_lv01'"
                @input="selectPackage('hal_express_package_special_group_lv01')"
                name="package_lv01">
                ແພັກເກດພິເສດ ລະດັບ 1
              </vs-checkbox>
            </div>
          </div>
          <div class="field column is-narrow">
            <div class="control">
              <vs-checkbox
                :value="item.package_name_group === 'hal_express_package_special_group_lv02'"
                @input="selectPackage('hal_express_package_special_group_lv02')"
                name="package_lv02">
                ແພັກເກດພິເສດ ລະດັບ 2
              </vs-checkbox>
            </div>
          </div>
          <div class="field column is-narrow">
            <div class="control">
              <vs-checkbox
                :value="item.package_name_group === 'hal_express_package_special_group_lv03'"
                @input="selectPackage('hal_express_package_special_group_lv03')"
                name="package_lv03">
                ແພັກເກດພິເສດ ລະດັບ 3
              </vs-checkbox>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="field column is-narrow">
            <div class="control">
              <vs-checkbox
                :value="item.package_name_group === 'domestic_pricing_package_group'"
                @input="selectPackage('domestic_pricing_package_group')"
                name="package_domestic">
                ແພັກເກດລາຄາພາຍໃນ
              </vs-checkbox>
            </div>
          </div>
          <div class="field column is-narrow">
            <div class="control">
              <vs-checkbox
                :value="item.package_name_group === 'domestic_pricing_south_package_group'"
                @input="selectPackage('domestic_pricing_south_package_group')"
                name="package_domestic_south">
                ແພັກເກດລາຄາພາຍໃນສໍາລັບພາກໃຕ້
              </vs-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div ref="target" id="target" class="center">
      <div class="con-btns">
        <vs-button
            ref="button"
            flat
            @click="ValidateForm()"
            class="form-btn-loading"
            :loading="loading"
        >ແກ້ໄຂຮ້ານຄ້າ
        </vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import CodCustomerSearch from "@/components/CodCustomerSearch";
import { Validator } from 'vee-validate';

const dict = {
  custom: {
    name: {
      required: '(ກະລຸນາປ້ອນກ່ອນ...)',
    },
    customer_id: {
      required: '(ກະລຸນາເລືອກລູກຄ້າ)',
    },
    is_active: {
      required: '(ກະລຸນາເລືອກສະຖານະຮ້ານ)',
    }
  }
};
Validator.localize('en', dict);

export default {
  props: [
    'item',
  ],
  components: {
    CodCustomerSearch
  },
  data() {
    return {
      loading: false,
      server_errors: {
        name: "",
        customer_id: "",
        is_active: "",
        package_name_group: "",
        general_error: ""
      }
    };
  },
  created() {
    // Fetch store details from API
    this.fetchStoreDetails();
  },
  methods: {
    selectPackage(packageName) {
      // Toggle logic: if the same package is selected, deselect it; otherwise select the new package
      if (this.item.package_name_group === packageName) {
        this.item.package_name_group = null;
        this.item.use_special_packages_price = false;
      } else {
        this.item.package_name_group = packageName;
        this.item.use_special_packages_price = true;
      }
    },
    fetchStoreDetails() {
      // Show loading indicator
      this.loading = true;

      // Make an API call to get store details
      this.$http.get(`v2/auth/store/management/store-detail/${this.item.id}`)
        .then((response) => {
          // Update item with data from API
          const storeData = response.data.data;

          // Update form fields with data from API
          this.item.name = storeData.name;
          this.item.customer_id = storeData.customer_id;
          this.item.is_active = storeData.is_active;
          // Handle package selection fields
          this.item.package_name_group = storeData.package_name_group || null;
          this.item.use_special_packages_price = storeData.use_special_packages_price || false;

          // Set cod customer details to display in the customer search component
          this.item.codCustomer = storeData.codCustomer;

          this.loading = false;
        })
        .catch((error) => {
          console.error('Error fetching store details:', error);
          this.loading = false;
        });
    },

    onCodCustomerSelected(customer) {
      this.item.codCustomer = customer;
      this.item.customer_id = customer ? customer.id : null;
      this.$validator.validate('customer_id');
    },
    ValidateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.SaveItem();
        }
      });
    },
    SaveItem() {
      this.loading = true;

      // Create a request body according to new API requirements
      const requestData = {
        name: this.item.name,
        customer_id: this.item.customer_id,
        is_active: this.item.is_active,
        package_name_group: this.item.package_name_group,
        use_special_packages_price: this.item.use_special_packages_price
      };

      this.$http.post('/v2/auth/store/management/update-store/' + this.item.id, requestData)
        .then(() => {
          this.loading = false;
          this.$emit('close');
          this.$emit('success');
        })
        .catch((error) => {
          this.loading = false;
          if (error.response && error.response.status === 422) {
            const obj = error.response.data.errors; // ໃຊ້ການລູບຂໍ້ມູນເພາະວ່າຂໍ້ມູນ errors ທີ່ສົ່ງມາຈາກ Server ນັ້ນເປັນ Array Object
            for (let [key, value] of Object.entries(obj)) {
              this.server_errors[key] = value[0];
            }
          } else if (error.response && error.response.status === 400) {
            // Handle status code 400 errors
            this.server_errors.general_error = error.response.data.message || "An error occurred";
          }
        });
    },
    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.button,
        scale: "0.6",
        background: "primary",
        opacity: 1,
        color: "#fff",
      });
    }
  },
  watch: {
    "item.name": function () {
      this.server_errors.name = "";
      this.server_errors.general_error = "";
    },
    "item.customer_id": function () {
      this.server_errors.customer_id = "";
      this.server_errors.general_error = "";
    },
    "item.is_active": function () {
      this.server_errors.is_active = "";
      this.server_errors.general_error = "";
    },
    "item.package_name_group": function () {
      this.server_errors.package_name_group = "";
      this.server_errors.general_error = "";
    },
    item: {
      deep: true,
      handler(newVal, oldVal) {
        // Check if the item ID has changed, which indicates a new item is being edited
        if (newVal && oldVal && newVal.id !== oldVal.id) {
          this.fetchStoreDetails();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.has-profile {
  border: none;
  height: 200px;
  width: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-repeat: no-repeat;
  background-size: 300px;
  background-position: center;

  &:hover {
    cursor: pointer;
  }
}

.box-upload-file {
  border: 1px dashed rgba(100, 98, 98, 0.867);
  height: 200px;
  width: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 5px;

  &:hover {
    cursor: pointer;
    border: 1px dashed $primary-color;

    .text-msg {
      i {
        color: $primary-color;
      }

      p {
        color: $primary-color;
      }
    }
  }

  .text-msg {
    i {
      font-size: 25px;
      color: rgba(100, 98, 98, 0.867);
    }

    .choose {
      margin-top: 10px;
      color: rgba(100, 98, 98, 0.867);
    }
  }
}
</style>
